"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ReferenceApi extends runtime.BaseAPI {
    /**
     * Get API Information
     */
    getApiInfoRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.APIFromJSON(jsonValue));
        });
    }
    /**
     * Get API Information
     */
    getApiInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getApiInfoRaw();
            return yield response.value();
        });
    }
    /**
     * Retrieve a list of countries
     */
    getCountriesRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/countries`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.CountryFromJSON));
        });
    }
    /**
     * Retrieve a list of countries
     */
    getCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCountriesRaw();
            return yield response.value();
        });
    }
    /**
     * Retrieve a list of states
     */
    getStatesRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/states`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.StateFromJSON));
        });
    }
    /**
     * Retrieve a list of states
     */
    getStates() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStatesRaw();
            return yield response.value();
        });
    }
}
exports.ReferenceApi = ReferenceApi;
